import useAsync from 'react-use/esm/useAsync';
import { bitriseApiRef } from '../plugin.esm.js';
import { useApi } from '@backstage/core-plugin-api';

const useBitriseBuilds = (appName, params) => {
  const bitriseApi = useApi(bitriseApiRef);
  const app = useAsync(
    async () => bitriseApi.getApp(appName),
    [appName]
  );
  const builds = useAsync(async () => {
    if (!app.value?.slug) {
      return { data: [] };
    }
    return bitriseApi.getBuilds(app.value.slug, params);
  }, [
    app.value?.slug,
    bitriseApi,
    params.workflow,
    params.branch,
    params.limit,
    params.next
  ]);
  return {
    loading: app.loading || builds.loading,
    error: app.error || builds.error,
    value: builds.value
  };
};

export { useBitriseBuilds };
//# sourceMappingURL=useBitriseBuilds.esm.js.map
